export default __webpack_public_path__ + "static/media/fund1.81e438b5.png";